import { createContext } from 'react'

/**
 * Optional render target for `DialogFooter`.
 *
 * Surrounding chrome (e.g. the track edit modal) can provide a DOM node to
 * host the footer, so the footer renders outside the scrolling content
 * instead of inline within it. When no target is provided the footer
 * renders in place, which is the default everywhere else.
 */
export const DialogFooterSlotContext = createContext<HTMLElement | null>(null)
